import { render } from "./location-detail.vue?vue&type=template&id=ca712af6"
import script from "./location-detail.vue?vue&type=script&lang=js"
export * from "./location-detail.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Projects\\YDN\\trunk\\zulin-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__